<template>
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-icon="AlarmClockOutlined"
	>
		<path
			d="M4.569 1.716a.982.982 0 1 1 1.38 1.397l-2.86 2.828a.982.982 0 1 1-1.38-1.397l2.86-2.828ZM18.04 3.113a.982.982 0 0 1 1.381-1.397l2.862 2.828a.982.982 0 0 1-1.38 1.397L18.04 3.113ZM12 8a1 1 0 0 1 1 1v3h3.001a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z"
			fill="currentColor"
		></path>
		<path
			d="M12.002 22.667c5.524 0 10.003-4.477 10.003-10s-4.479-10-10.003-10S2 7.144 2 12.667s4.478 10 10.002 10Zm0-2a8 8 0 1 1 0-16 8.001 8.001 0 1 1 0 16Z"
			fill="currentColor"
		></path>
	</svg>
</template>
